import { render, staticRenderFns } from "./formCommentPanel.vue?vue&type=template&id=2b00a4f3&scoped=true&"
import script from "./formCommentPanel.vue?vue&type=script&lang=js&"
export * from "./formCommentPanel.vue?vue&type=script&lang=js&"
import style0 from "./formCommentPanel.vue?vue&type=style&index=0&id=2b00a4f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00a4f3",
  null
  
)

export default component.exports